/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const USER_MCP_QUERY_KEYS = {
  catalog: ['user-mcps', 'catalog'] as const,
  installed: ['user-mcps', 'installed'] as const,
  health: (mcpCatalogId: string) => ['user-mcps', 'health', mcpCatalogId] as const,
  agentAssigned: (agentId: string) => ['user-mcps', 'agent-assigned', agentId] as const,
  builtIn: ['user-mcps', 'built-in'] as const,
};
